import { Grid } from "@mui/material";
import { useAudienceAnalyticsContext } from "Providers/AudienceAnalyticsProvider";
import { AudiencePickerSubAction } from "Pages/Analyse/Audiences";
import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { AnalyticsSpacing } from "consts";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import {
  CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_DEVICE,
  CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_DEVICE_PIE,
  CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_VISITOR_TYPE,
  CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_VISITOR_TYPE_PIE,
  CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_PERFORMANCE_BUBBLE,
  CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_PRIMARY_STATS,
} from "features/analytics/constants/chartKeys";

function AudienceEngagementTab() {
  const { audienceAttributes } = useAudienceAnalyticsContext();
  return (
    <>
      <AudiencePickerSubAction />
      <Grid container spacing={AnalyticsSpacing}>
        <Grid item xs={6} sx={{ minHeight: 500 }}>
          <StandardAnalyticsCard
            chartKey={
              CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_PERFORMANCE_BUBBLE
            }
            chart={{
              name: "Audience Engagement Performance",
              dimension: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.BUBBLE,
              attributes: audienceAttributes,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [
                    ApiMetric.METRIC_SESSIONS_COUNT,
                    ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                    ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
                  ],
                },
              ],
              displayOptions: {
                noFilters: true,
              },
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <StandardAnalyticsCard
            chartKey={CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_PRIMARY_STATS}
            chart={{
              name: "Audience Primary Stats",
              dimension: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              template: ApiChartTemplate.TABLE,
              type: ApiChartType.TABLE,
              attributes: audienceAttributes,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [
                    ApiMetric.METRIC_SESSIONS_COUNT,
                    ApiMetric.METRIC_PAGEVIEWS_COUNT,
                    ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE,
                    ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                    ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
                    ApiMetric.METRIC_PAGE_MICRO_CONVERSIONS_COUNT,
                  ],
                },
              ],
              displayOptions: {
                noFilters: true,
              },
            }}
          />
        </Grid>
        <Grid item xs={8} sx={{ minHeight: 500 }}>
          <StandardAnalyticsCard
            chartKey={
              CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_VISITOR_TYPE
            }
            chart={{
              name: "Audience Effective Sessions by Visitor Type",
              dimension: [
                ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                ApiDimension.DIMENSION_LEAD_AUDIENCE,
              ],
              template: ApiChartTemplate.TREND,
              type: ApiChartType.GRAPH,
              attributes: audienceAttributes,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_EFFECTIVE_SESSIONS_COUNT],
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_VISITOR_TYPE],
              },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <StandardAnalyticsCard
            chartKey={
              CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_VISITOR_TYPE_PIE
            }
            chart={{
              name: "Audience Effective Sessions by Visitor Type Composition",
              dimension: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.PIE,
              attributes: audienceAttributes,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_EFFECTIVE_SESSIONS_COUNT],
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_VISITOR_TYPE],
                showTotals: true,
              },
            }}
          />
        </Grid>
        <Grid item xs={8} sx={{ minHeight: 500 }}>
          <StandardAnalyticsCard
            chartKey={
              CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_DEVICE
            }
            chart={{
              name: "Audience Effective Sessions by Device",
              dimension: [
                ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                ApiDimension.DIMENSION_LEAD_AUDIENCE,
              ],
              template: ApiChartTemplate.TREND,
              type: ApiChartType.GRAPH,
              attributes: audienceAttributes,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_EFFECTIVE_SESSIONS_COUNT],
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_DEVICE],
              },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <StandardAnalyticsCard
            chartKey={
              CHART_KEY_AUDIENCE_COMPARISON_ENGAGEMENT_EFFECTIVE_SESSIONS_BY_DEVICE_PIE
            }
            chart={{
              name: "Audience Effective Sessions by Device Composition",
              dimension: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.PIE,
              attributes: audienceAttributes,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_EFFECTIVE_SESSIONS_COUNT],
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_DEVICE],
                showTotals: true,
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default AudienceEngagementTab;
